import { useQuery } from '@tanstack/react-query';
import { StreamingOffer } from '../../../interfaces/StreamingOffer.interface';
import { getStreamingOffer } from '../../../services/api/getStreamingOffer';

export const useStreamingOffer = () => {
  const { data, isLoading, error } = useQuery<StreamingOffer[], string>({
    queryKey: ['streamingoffer'],
    queryFn: () => {
      return getStreamingOffer();
    },
  });

  return { streamingOffer: data ?? [], loading: isLoading, error };
};
